export type ExecutionRunsPageLocationState = {
  notice?: string;
  postOnboardingAnnouncement?: boolean;
  postOnboardingTutorial?: boolean;
} | null;

export const resolveExecutionRunsRouteNotice = (
  locationState: ExecutionRunsPageLocationState,
): string | null =>
  typeof locationState?.notice === 'string' && locationState.notice.length > 0
    ? locationState.notice
    : null;

export const resolveForceOpenTutorial = (tutorialParam: string | null): boolean =>
  import.meta.env.DEV && ['1', 'true'].includes((tutorialParam ?? '').toLowerCase());

export const resolveOnboardingJustCompleted = (
  locationState: ExecutionRunsPageLocationState,
  pendingState: { showTutorial?: boolean } | null,
): boolean => locationState?.postOnboardingTutorial === true || pendingState?.showTutorial === true;
